const NoResults = () => {
  return (
    <div>
      <p>No results found</p>
    </div>
  );
};

export default NoResults;
